import React from 'react';
import { SxProps } from '@mui/material';

import HomeBottomButtonOptionsSettings from '@core/dashboard/components/HomeBottomBar/HomeBottomButtonOptionsSettings';
import { useMytaverse } from '@providers/MytaverseProvider';
import { getAiAssistantLanguageOptions } from '@helpers/assistant';
import { env } from 'env';

const { REACT_APP_FEATURE_SHOW_LANGUAGE = 'true' } = env;
const showLanguage = REACT_APP_FEATURE_SHOW_LANGUAGE === 'true';

interface LanguageSelectorProps {
  label: string;
  sx?: SxProps;
}

const LanguageSelector = ({ label, sx }: LanguageSelectorProps) => {
  const { appSettings, selectLanguage, selectedLanguage } = useMytaverse();

  const languageOptions = getAiAssistantLanguageOptions(appSettings?.aiAssistant);

  if (!showLanguage || !languageOptions?.length) {
    return null;
  }

  return (
    <HomeBottomButtonOptionsSettings
      devices={languageOptions.map(({ label: l, key }) => ({ label: l, deviceId: key }))}
      handleSelect={(e) => selectLanguage(e.target.value)}
      label={label}
      selectedValue={selectedLanguage}
      sx={sx}
    />
  );
};

export default LanguageSelector;
